import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import { formatTimeStamp } from 'lib/util';

const HistoricsReportRow = ({
  locations = [],
  record,
  handleToggleCollapsed,
  handleGeneratePDF,
  isSaving,
  handleAccept,
  handleReject,
  collapsed,
  t,
}) => {
  // * // createdAt: "2021-04-25T21:51:55.957Z"
  // * // ejecutionDate: "2021-04-25T21:52:01.983Z"
  // * // event: "reject out"
  // img_asset: "https://controlactivofijo.s3.us-east-2.amazonaws.com/606bd1ce1a44d119f880dc0f/606bd1d91a44d119f880dc3e/files/60825af5f3a3176a26c38ae2.png"
  // isOut: false
  // max_time: "70"
  // * // message: ""
  // * // name: "4"
  // needsAuthorization: true
  // number: "4"
  // outAuthorized: false
  // * // outDate: "2021-04-23T16:30:47.228Z"
  // role_to_acept: "606bd1ce1a44d119f880dc3c"
  // * // _user_request
  // * // _user_authorized
  // * // _employee
  console.log('%c ' + record, 'background: #222; color: #bada55');
  const { out } = record.changes;
  return (
    <Fragment>
      <tr>
        <td className="text-center align-middle">
          <span
            className={classnames('badge ', {
              'badge-warning': out.event === 'out',
              'badge-info': out.event === 'in',
              'badge-success': out.event === 'acept out',
              'badge-secondary': out.event === 'out request',
              'badge-danger': out.event === 'reject out',
            })}
          >
            {t(`assets.fields.out.${out.event}`)}
          </span>
        </td>
        <td className="text-center align-middle">{formatTimeStamp(out.createdAt)}</td>
        {/* <td className="text-center align-middle">{out.ejecutionDate ? formatTimeStamp(out.ejecutionDate) : ""}</td> */}
        <td className="text-center align-middle">
          {out._user_request
            ? `${out._user_request.name} ${out._user_request.lastname}`
            : 'Sistema'}
        </td>
        {/* <td className="text-center align-middle">{`${record._createdBy.name} ${record._createdBy.lastname} (${record._createdBy.email})`}</td> */}
        {/* <td className="text-center align-middle">
          {out._user_authorized
            ? `${out._user_authorized.name} ${out._user_authorized.lastname}`
            : "Sistema"
          }
        </td> */}
        {/* <td className="text-center align-middle">{`${record._reviewedBy.name} ${record._reviewedBy.lastname} (${record._reviewedBy.email})`}</td> */}
        <td className="text-center align-middle">{record._asset.number}</td>
        <td className="text-center align-middle">{record._asset.name}</td>
        <td className="text-center align-middle">{out.message}</td>
        <td className="text-center align-middle">
          {out._employee ? `${out._employee.name} ${out._employee.lastname}` : ''}
        </td>
        <td className="text-center align-middle">
          {out.role_to_acept ? out.role_to_acept.name : ''}
        </td>
        {/* <td className="text-center align-middle">
          {record._asset._employee
            ? `${record._asset._employee.name} ${record._asset._employee.lastname}`
            : "Sin empleado asignado"}
        </td> */}
        {/* <td className={`text-center align-middle 
          ${record._asset._employee == null ? "table-default" : record._asset.validated ? "table-success" : "table-info"}`
        }>
          {record._asset._employee == null ? "Sin Asignar" : record._asset.validated ? "Aceptado" : "Por aceptar"}
        </td> */}
        {/* <td>{record._asset.position}</td> */}
        {/* <td className="text-center">{record._asset.total}</td> */}

        {/* <td className="text-center">
          <a
            className="btn btn-outline-success btn-sm mx-2"
            href="#expand"
            onClick={(e) => {
              e.preventDefault();
              handleToggleCollapsed();
            }}
          >
            {t(
              !collapsed
                ? "reports.historics.hideAssets"
                : "reports.historics.showAssets"
            )}
            &nbsp;
            <i
              className={classnames("fa", {
                "fa-angle-down": collapsed,
                "fa-angle-up": !collapsed,
              })}
            />
          </a>
          {record.status === "PENDING" && (
            <a
              className={classnames("btn btn-outline-danger btn-sm mx-1", {
                "is-loading": isSaving
              })}
              href={"#reject-historic"}
              onClick={e => {
                e.preventDefault();
                handleReject(record);
              }}
            >
              {t("actions.reject")}
            </a>
          )}
          {record.status === "PENDING" && (
            <a
              className={classnames("btn btn-outline-primary btn-sm mx-1", {
                "is-loading": isSaving
              })}
              href={"#accept-historic"}
              onClick={e => {
                e.preventDefault();
                handleAccept(record);
              }}
            >
              {t("actions.accept")}
            </a>
          )}
        </td> */}
      </tr>
      <tr className={classnames('table-active', { 'd-none': collapsed })}>
        <td colSpan="7">
          <div className="table-reponsive position-relative">
            <table className="table table-condensed">
              <thead>
                {/* <tr className="text-center">
                <th colSpan="4">{t('reports.historics.assigned')}</th>
              </tr> */}
                {/* <tr>
                  <th>{t("reports.fields.historics.number")}</th>
                  <th>{t("reports.fields.historics.name")}</th>
                  <th>{t("reports.fields.historics.brand")}</th>
                  <th>{t("reports.fields.historics.model")}</th>
                  <th>{t("reports.fields.historics.serie")}</th>
                </tr> */}
                <tr>
                  <th width="20%">{t('assets.fields.historics.field')}</th>
                  <th width="35%">{t('assets.fields.historics.before')}</th>
                  <th width="35%">{t('assets.fields.historics.after')}</th>
                  {record.status === 'PENDING' && (
                    <th width="5%">
                      <a
                        className={classnames('btn btn-outline-danger btn-sm mx-1', {
                          'is-loading': isSaving,
                        })}
                        href={'#reject-historic'}
                        onClick={(e) => {
                          e.preventDefault();
                          handleReject(record);
                        }}
                      >
                        {t('actions.reject')}
                      </a>
                    </th>
                  )}
                  {record.status === 'PENDING' && (
                    <th width="5%">
                      <a
                        className={classnames('btn btn-outline-primary btn-sm mx-1', {
                          'is-loading': isSaving,
                        })}
                        href={'#accept-historic'}
                        onClick={(e) => {
                          e.preventDefault();
                          handleAccept(record);
                        }}
                      >
                        {t('actions.accept')}
                      </a>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {record.differences.map((diff, index) =>
                  diff.field === 'location' ? (
                    <tr key={index}>
                      <td>{t(`assets.fields.${diff.field}`)}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before
                            .split('.')
                            .map((p) => locations[p] && locations[p].name)
                            .filter((l) => l)
                            .join(' <br/> '),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after
                            .split('.')
                            .map((p) => locations[p] && locations[p].name)
                            .filter((l) => l)
                            .join(' <br/> '),
                        }}
                      />
                    </tr>
                  ) : diff.field === 'files' ? (
                    <tr key={index}>
                      <td>{t(`assets.fields.${diff.field}`, { defaultValue: diff.field })}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before.split(', ').join(' <br/>'),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after.split(', ').join(' <br/>'),
                        }}
                      />
                    </tr>
                  ) : diff.field === 'notes' ? (
                    <tr key={index}>
                      <td>{t(`assets.fields.${diff.field}.text`, { defaultValue: diff.field })}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before.split(', ').join(' <br/>'),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after.split(', ').join(' <br/>'),
                        }}
                      />
                    </tr>
                  ) : (
                    <tr key={index}>
                      <td>
                        {t(`assets.fields.${diff.field}`, { defaultValue: diff.field || '-' })}
                      </td>
                      <td>
                        {t(
                          typeof diff.before === 'boolean'
                            ? diff.before
                              ? 'common.yes'
                              : 'common.no'
                            : typeof diff.before === 'string'
                            ? diff.before
                            : JSON.stringify(diff.before)
                        )}
                      </td>
                      <td>
                        {t(
                          typeof diff.after === 'boolean'
                            ? diff.after
                              ? 'common.yes'
                              : 'common.no'
                            : typeof diff.after === 'string'
                            ? diff.after
                            : JSON.stringify(diff.after)
                        )}
                      </td>
                    </tr>
                  )
                )}
                {/* {record.assets.map((asset) => (
                  <tr key={asset.id}>
                    <td>{asset.number}</td>
                    <td>{asset.name}</td>
                    <td>{asset.brand}</td>
                    <td>{asset.model}</td>
                    <td>{asset.serie}</td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </Fragment>
  );
};

export default translate()(HistoricsReportRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/ins_outs/InsOutsReportRow.js